import React from 'react';

const MigrateDevOverlay = () => (
  <div className='migrateDevOverlay'></div>
);

export default MigrateDevOverlay;